import type { GeoJSON } from "geojson";

/** Geo item with no record association. */
export interface GeoItemCreateFormData {
  startDate: string;
  endDate: string;
  jaLabel: string;
  enLabel: string;
  h3Indexes: string[];
  geometry: GeoJSON | null;
  memo: string;
}

export type GeoItemCreateAreaInputMode = "h3" | "geoJson";

/** 単体GeoItem作成画面で、この端末のブラウザ内に保持する状態。 */
export interface GeoItemCreateDraftData {
  form: GeoItemCreateFormData;
  areaInputMode: GeoItemCreateAreaInputMode;
  resolution: 0 | 1 | 2 | 3 | 4;
  geoJsonText: string;
  h3IndexesDraft: string[];
  geometryDraft: GeoJSON | null;
}

export const emptyGeoItemCreateForm: GeoItemCreateFormData = {
  startDate: "",
  endDate: "",
  jaLabel: "",
  enLabel: "",
  h3Indexes: [],
  geometry: null,
  memo: "",
};
